import { useEffect } from 'react';
import { useMySettingsApi } from '../../api';
import { useLocalStorageThemeKey } from './useLocalStorageThemeKey';
/**
 * If the API theme changes, update the theme in local storage.
 */
export const useEffectSetStorageThemeFromApi = () => {
    const { data, isLoading } = useMySettingsApi();
    /** The theme from the API */
    const apiThemeKey = data === null || data === void 0 ? void 0 : data.theme;
    const [storageThemeKey, setStorageThemeKey] = useLocalStorageThemeKey();
    useEffect(() => {
        if (apiThemeKey &&
            storageThemeKey !== apiThemeKey &&
            apiThemeKey !== null &&
            !isLoading) {
            setStorageThemeKey(apiThemeKey);
        }
    }, [apiThemeKey, isLoading, setStorageThemeKey, storageThemeKey]);
};
